import React, { Fragment } from "react";
import Header from "../component/Header";
import classes from './Template.module.css';

export const RightPart = ({ children }) => {
    return (
        <div className={classes.homeRight}>
            <Header />
            {children}
        </div>
    )
}